// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__kEncE","loader":"Spinner_loader__2osxn","rotation":"Spinner_rotation__kHtIV"};